import { useMemo } from "react";

const ROOTS = [
  [0, 1000, -0.9], [0, 620, -0.15], [0, 180, 0.35], [400, 1000, -1.3], [1100, 1000, -1.9],
  [1600, 1000, -2.4], [1600, 520, 3.1], [1600, 80, 2.7], [800, 0, 1.6],
];

function grow(x, y, angle, depth, out) {
  let d = `M${x.toFixed(0)} ${y.toFixed(0)}`;
  let cx = x;
  let cy = y;
  const segs = 6 + Math.floor(Math.random() * 7);
  for (let i = 0; i < segs; i++) {
    angle += (Math.random() - 0.5) * 0.9;
    const len = 28 + Math.random() * 55;
    const nx = cx + Math.cos(angle) * len;
    const ny = cy + Math.sin(angle) * len;
    const qx = (cx + nx) / 2 + (Math.random() - 0.5) * 24;
    const qy = (cy + ny) / 2 + (Math.random() - 0.5) * 24;
    d += ` Q${qx.toFixed(0)} ${qy.toFixed(0)} ${nx.toFixed(0)} ${ny.toFixed(0)}`;
    cx = nx;
    cy = ny;
    if (depth < 3 && out.length < 90 && Math.random() < 0.33) {
      grow(cx, cy, angle + (Math.random() < 0.5 ? -1 : 1) * (0.5 + Math.random() * 0.7), depth + 1, out);
    }
  }
  out.push({ d, depth, end: [cx, cy] });
}

export default function MyceliumCreep() {
  const paths = useMemo(() => {
    const out = [];
    ROOTS.forEach(([x, y, a]) => grow(x, y, a, 0, out));
    return out;
  }, []);

  return (
    <svg className="mycelium" viewBox="0 0 1600 1000" preserveAspectRatio="none" aria-hidden="true" data-testid="mycelium-creep">
      {paths.map((p, i) => {
        const style = {
          "--delay": `${(p.depth * 2.4 + Math.random() * 2).toFixed(2)}s`,
          "--dur": `${(7 + Math.random() * 5).toFixed(2)}s`,
          strokeWidth: Math.max(0.7, 2.6 - p.depth * 0.6),
        };
        return (
          <g key={i}>
            <path d={p.d} pathLength="1" style={style} />
            {p.depth > 0 && <circle cx={p.end[0]} cy={p.end[1]} r={3 - p.depth * 0.5} style={style} />}
          </g>
        );
      })}
    </svg>
  );
}
